import React, { lazy } from "react";
import { RouteProps, Redirect } from "react-router-dom";

const ImportantMotifs = lazy(() => import("../pages/important-motifs"));
const ImportantMotifsResult = lazy(
  () => import("../pages/important-motifs/result")
);
const StabilityScore = lazy(() => import("../pages/stability-score"));
const StabilityScoreResult = lazy(
  () => import("../pages/stability-score/result")
);
const SimilarSequences = lazy(() => import("../pages/similar-sequences"));
const SimilarSequencesResult = lazy(
  () => import("../pages/similar-sequences/result")
);

const routes: RouteProps[] = [
  {
    path: "/",
    exact: true,
    component: (): JSX.Element => <Redirect to="/important-motifs" />,
  },
  {
    path: "/important-motifs",
    exact: true,
    component: ImportantMotifs,
  },
  {
    path: "/important-motifs/:seq",
    component: ImportantMotifsResult,
  },
  {
    path: "/stability-score/",
    exact: true,
    component: StabilityScore,
  },
  {
    path: "/stability-score/:proteinA/:proteinB",
    component: StabilityScoreResult,
  },
  {
    path: "/similar-sequences",
    exact: true,
    component: SimilarSequences,
  },
  {
    path: "/similar-sequences/:seq",
    component: SimilarSequencesResult,
  },
];

export default routes;
